import { Bar, BarChart, CartesianGrid, LabelList, XAxis, YAxis } from 'recharts'
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/shared/components/ui/chart'
import type { ModuloEstadisticas } from '../types'

const chartConfig = {
  aprobados: { label: 'Aprobados', color: '#8b5cf6' },
  sin_aprobar: { label: 'Sin aprobar', color: '#e5e7eb' },
} satisfies ChartConfig

interface AprobacionChartProps {
  modulos: ModuloEstadisticas[]
}

export function AprobacionChart({ modulos }: AprobacionChartProps) {
  const data = modulos.map((m) => ({
    name: `M${m.numero}`,
    aprobados: m.tasa_aprobacion,
    sin_aprobar: Math.max(0, 100 - m.tasa_aprobacion),
    tasa: m.tasa_aprobacion,
  }))

  return (
    <ChartContainer config={chartConfig} className="h-full min-h-[200px] w-full">
      <BarChart data={data} margin={{ top: 20, right: 0, left: 0, bottom: 0 }}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="name" tickLine={false} axisLine={false} />
        <YAxis hide domain={[0, 100]} />
        <ChartTooltip content={<ChartTooltipContent />} />
        <Bar dataKey="aprobados" stackId="a" fill="var(--color-aprobados)" radius={[0, 0, 0, 0]} />
        <Bar dataKey="sin_aprobar" stackId="a" fill="var(--color-sin_aprobar)" radius={[4, 4, 0, 0]}>
          <LabelList
            dataKey="tasa"
            position="top"
            formatter={(v: number) => `${v}%`}
            className="fill-muted-foreground text-[11px] font-medium"
          />
        </Bar>
      </BarChart>
    </ChartContainer>
  )
}
